<template>
<div class="dashboard">
    <h1 class="subheading grey--text">Reservationer</h1>
    <v-container class="mt-1">
        <v-layout row wrap justify-center justify-space-around>
            <v-alert v-model="showAlertApprove" color="error">
                Din konto er ikke godkendt endnu. Derfor kan du ikke oprette reservationer endnu. Indtast kode på min side eller vent på godkendelse.
            </v-alert>
            <v-flex xs12 md12>
                <v-menu>
                    <v-btn slot="activator">
                        <v-icon>date_range</v-icon> {{formattedDate}}
                    </v-btn>
                    <v-date-picker v-model="dateSelected" :min="dateCurrent" :max="maxDate"></v-date-picker>
                </v-menu>
                <Popup button-type='round' @bookingAdded="snackbar = true" v-if="userSession && approved" />
            </v-flex>

        </v-layout>
    </v-container>
 
    <v-container class="">
        <v-flex xs12>
            <div class="grey--text">Fold</div>
        </v-flex>
        <v-divider></v-divider>
        <v-layout row wrap justify-center justify-space-around>
            <v-flex xs2 sm1 md1 v-for="resource in resources" :key="resource.id">
                <v-btn @click="$store.dispatch('setResid', resource.id)" small flat fab :style="[{'background': `${selected(resource.id,$store.getters.resid) }`},{'color': `${selectedText(resource.id,$store.getters.resid) }`}]">{{resource.name}}</v-btn>
            </v-flex>
        </v-layout>
    </v-container>

    <v-container class="my-1">
        <v-flex xs12>
            <div class="grey--text">Reservationer</div>
        </v-flex>
        <v-divider></v-divider>
        <Bookings />

    </v-container>

</div>
</template>

<script>
import Popup from '@/components/Popup'
import Bookings from '@/components/Bookings';
import format from 'date-fns/format'

export default {
    components: {
        Popup,
        Bookings
    },
    data() {
        return {

            time: {
                hour: new Date().getHours(),
                day: new Date().getDay(),
                month: new Date()
            },
        }
    },
    computed: {
        approved() {

            if (this.$store.getters.profile === null || this.$store.getters.profile == null || typeof this.$store.getters.profile === 'undefined')
                return false
            else {
                if (this.$store.getters.profile.approved)
                    return true
                else
                    return false
            }
        },
        userSession() {
            //console.log('#Navbar  userSession')
            if (this.$store.getters.authUser)
                return true
            else
                return false
        },
        showAlertApprove() {

            if (this.$store.getters.profile === null || this.$store.getters.profile == null || typeof this.$store.getters.profile === 'undefined')
                return false
            else {

                if (this.$store.getters.profile.approved === null || this.$store.getters.profile.approved == null || typeof this.$store.getters.profile.approved === 'undefined') {
                    return false
                } else {                    
                    if (this.$store.getters.profile.approved) {                        
                        return false
                    } else {                        
                        return true
                    }
                }

            }

        },
        users() {
            return this.$store.getters.users
        },
        horses() {
            return this.$store.getters.horses
        },
        resources() {
            return this.$store.getters.resources
        },
        bookings() {
            return this.$store.getters.bookings
        },
        userid() {
            return this.$store.getters.authUser.uid
        },
        formattedDate() {
            return this.$store.getters.dateSelected ? format(this.$store.getters.dateSelected, 'DD MMM YYYY') : ''
        },
        noBookings() {
            return this.bookings.filter(booking => {
                return booking.resid === this.$store.getters.resid && booking.date === this.$store.getters.dateSelected
            }).length
        },
        dateSelected: {
            //getter
            get: function () {
                return this.$store.getters.dateSelected
            },
            // setter
            set: function (newValue) {
                this.$store.dispatch('setDateSelected', newValue);
            }          
        },
        dateCurrent() {
            return this.$store.getters.dateCurrent
        },
        maxDate() {
            return this.$store.getters.maxDate
        },
        date() {
            return new Date()
        },
    },
    created: function () {
 
    },
    methods: {

        resourceName(resources, resid) {
            let resource = []
            resource = this.resourceById(resources, resid)
            if (typeof resource !== 'undefined') {
                return resource.name
            } else {
                return ''
            }
        },
        resourceById(resources, residToFind) {
            const resource = resources.find(function (resource) {
                return resource.id === residToFind;
            })

            return resource
        },
        horseName(horses, horseid) {
            let horse = []
            horse = this.horseById(horses, horseid)
            if (typeof horse !== 'undefined') {
                return horse.name
            } else {
                return 'Ukendt'
            }
        },
        horseById(horses, horseidToFind) {
            const horse = horses.find(function (horse) {
                return horse.id === horseidToFind;
            })
            return horse
        },
        userName(users, userid) {
            let user = []
            user = this.userById(users, userid)
            if (typeof user !== 'undefined') {
                return user.name
            } else {
                return ''
            }
        },
        userById(users, useridToFind) {
            const user = users.find(function (user) {
                return user.id === useridToFind;
            })
            return user
        },
        sortBy(prop) {
            this.bookings.sort((a, b) => a[prop] < b[prop] ? -1 : 1)
        },
        status: function (timestart, timeend) {
            if (timeend < this.time.hour)
                return 'complete'
            if (timestart < this.time.hour && timeend > this.time.hour)
                return 'ongoing'
            if (timestart > this.time.hour)
                return 'notstarted'
        },
        selected: function (id1, id2) {
            if (id1 === id2) {
                return '#1976d2'
            } else
                return ''
        },
        selectedText: function (id1, id2) {
            if (id1 === id2) {
                return 'white'
            } else
                return ''
        }
    },
    watch: {

    },
    mounted() {

    }
}
</script>

<style>
.complete {
    border-left: 4px solid grey;
    background-color: #eeeeee;
}

.ongoing {
    border-left: 4px solid orange
}

.notstarted {
    border-left: 4px solid #1976d2
}

.selected {
    background-color: #858585;
}
</style>
